<div class="dialog-header gbg">
    <div class="dialog-title fs20">
        File Upload: {{ddata.title}} {{this.inboxid}}
    </div>
</div>

<div class="dialog-body">
    <form [formGroup]="iForm" name="iForm" (ngSubmit)="onSubmit()">
        <div class="row">
            <div class="col-md-12 mb-3">
                <table>
                    <tr>
                        <td>
                            <span class="bold c-grey fs12">Supported File Formats: &nbsp;&nbsp;<span class="bold c-danger fs12">.PNG, .JPG, .JPEG, .PDF</span></span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span class="bold c-grey fs12">Maximum File Size Limit: &nbsp;&nbsp;<span class="bold c-danger fs12">5MB</span></span>
                        </td>
                        
                    </tr>
                </table>
            </div>
          </div>
        <div class="row">
            <div class="col-md-12 text-center" *ngIf="!isFileUploaded">
                <mat-form-field appearance="fill" class="w100">
                    <mat-label>Please Select File</mat-label>
                    <ngx-mat-file-input formControlName="file" (change)="onFileChange($event)" placeholder="Basic fill placeholder" accept="image/png, image/jpeg, image/jpg, .pdf" [disabled]="disabled" #fileUpload required></ngx-mat-file-input>
                    <mat-icon matSuffix *ngIf="fileUpload.empty">folder</mat-icon>
                    <button mat-icon-button matSuffix *ngIf="!fileUpload.empty" (click)="fileUpload.clear($event); hasFile = false;">
                        <mat-icon>clear</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div class="col-md-12 text-center" *ngIf="!isFileUploaded">
                <div style="width:100%;" *ngIf="hasFile  === true">
                    <span class="c-green bold">Press below button to finish upload. </span> <br />
                    <i class="fas fa-arrow-circle-down fs14 c-deep-orange blink"></i>
                </div>
            </div>
            <div class="col-md-12 text-center" *ngIf="hasFile === true">
                <button mat-raised-button type="submit" color="accent" class="c-white" style="margin-top:15px;"><i class="fas fa-upload fs16"></i> Upload</button>
            </div>
            <div class="col-md-12 text-center" *ngIf="isFileUploaded">
                <span class="c-dark-grey fs20"><i class="fas fa-check-circle c-green"></i> File Uploaded Successfully</span>
            </div>
        </div>
    </form>
    <ngx-loading [show]="uloading"></ngx-loading>
</div>
<div class="dialog-footer text-center">
    <button mat-raised-button (click)="close()"><i class="fas fa-times"></i>&nbsp;Close</button>
</div>